<ng-container *ngIf="privacyForm">
  <h4 class="wizard-h3">What can CurbNTurfers see when they are at the site?</h4>
  <div class="_12-px-spacer"></div>
  <div class="button-wrapper-grid">
    <label [ngClass]="{ active: secluded?.value }" class="cnt-button">
      <input type="checkbox" [formControl]="secluded" (change)="isolateSecluded(true)" />
      <div class="cnt-button-copy">It&rsquo;s Secluded</div>
    </label>
    <label [ngClass]="{ active: home?.value }" class="cnt-button">
      <input type="checkbox" [formControl]="home" (change)="isolateSecluded(false)" />
      <div class="cnt-button-copy">My Home</div>
    </label>
    <label [ngClass]="{ active: neighbor?.value }" class="cnt-button">
      <input type="checkbox" [formControl]="neighbor" (change)="isolateSecluded(false)" />
      <div class="cnt-button-copy">My Neighbor</div>
    </label>
    <label [ngClass]="{ active: others?.value }" class="cnt-button">
      <input type="checkbox" [formControl]="others" />
      <div class="cnt-button-copy">Other Guests</div>
    </label>
  </div>
  <p *ngIf="privacyError" class="alert-danger">
    <i class="icon-cnt-times-circle"></i>
    {{ privacyError }}
  </p>
</ng-container>
